<dv-dynamic-form
  [elements]="tab.serviceElements | translateElements"
  [formGroup]="lastServiceForm"
  formTitle="{{ 'Vehicles.Service.Service' | translate | uppercase }}">
</dv-dynamic-form>
<hr class="form-divider" />
<dv-dynamic-form
  [elements]="tab.serviceIntervalElements | translateElements"
  [formGroup]="lastServiceForm"
  formTitle="{{ 'Vehicles.Service.ServiceInterval' | translate | uppercase }}">
</dv-dynamic-form>
<hr class="form-divider" />
<dv-dynamic-form
  class="dynamic-form-background"
  [elements]="tab.lastServiceElements | translateElements"
  [formGroup]="lastServiceForm"
  formTitle="{{ 'Vehicles.Service.LastServiceInfo' | translate | uppercase }}">
</dv-dynamic-form>
<hr class="form-divider" />
<dv-dynamic-form
  [elements]="serviceElements | translateElements"
  [formGroup]="nextServiceForm"
  formTitle="{{ 'Vehicles.Service.NextServiceInfo' | translate | uppercase }}">
</dv-dynamic-form>
<hr class="form-divider" />
<dv-dynamic-form
  class="dynamic-form-background"
  [elements]="nextRoadWorthinessTestElements | translateElements"
  [formGroup]="nextServiceForm"
  formTitle="{{
    'Vehicles.Service.NextRoadWorthinessTest' | translate | uppercase
  }}">
</dv-dynamic-form>
<div class="dynamic-form-background">
  <div class="get-latest-data">
    <dv-button
      (click)="getLatestData()"
      [disabled]="!selectedVehicleRegNumber || !!isVehicleDeleted">
      {{ 'Vehicle.Service.GetLatestData' | translate | uppercase }}</dv-button
    >
  </div>
</div>
<dv-save-panel
  labelCancel=""
  labelSave="{{ 'General.Save' | translate }}"
  [disableSave]="!lastServiceForm.dirty && !nextServiceForm.dirty"
  (save)="onSave()">
</dv-save-panel>
